module.exports = __webpack_public_path__ + "img/zinc_gallery_3.4dc591cb.jpg";